export class ZefGithubState {
  repositories: ZefGithubRepository[];
  authorized: boolean;
  branchMap: Record<string, Array<ZefGithubBranch>>;
}

export enum ZefGithubAuthUrlType {
  Registration = 'REGISTRATION',
  Login = 'LOGIN',
  Repository = 'REPOSITORY'
}

export interface ZefGithubConfig {
  callbackUrl?: string;
  apiUrl?: string;
}

export interface ZefGithubRepository {
  fullName: string;
  name: string;
  owner: string;
  ownerUrl: string;
  private: boolean;
}

export interface ZefGithubBranch {
  name: string;
  isDefault: boolean;
}

export interface ZefGithubAuthUrlResponse {
  githubUrl: string;
}

export interface ZefGithubApiAuthorizePayload {
  state: string;
  code: string;
  // Only meaningful on the signup call: a promo code carried through the OAuth
  // round-trip from a deep link.
  promoCode?: string;
  // Likewise the ZCP-pool claim. The backend takes it on this body, the same
  // way the native registration sends it.
  claimZcpPool?: boolean;
}

export interface ZefGithubAuthStateData {
  action: ZefGithubAuthUrlType;
  key: string;
  nonHaRecipe?: string;
  haRecipe?: string;
  email?: string;
  /**
   * A Zerops Code sign-in hand-over, as one base64 object. Rides the state the
   * same way the recipe ids do — the provider hands it back at the callback,
   * which is the only way it survives the round trip to a different route.
   */
  z3?: string;
}
